export const FREQUENCY_INTERVAL = {
    WEEKILY: 1,
    DAILY: 2,
    THROUGHOUT_CAMPAIGN: 3
};

